import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import adminRoutes from '../../routes/adminRoutes'
import clipboardUtil from '../../utils/clipboard.util'
import userApi, { UserData } from '../../apis/user.api'
import userService from '../../services/user.service'
import { ActionName } from '../../components/Actions'
import Button from '../../components/Button'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import HeadingRow from '../../components/HeadingRow'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../../components/TableHorizontal'
import Card from '../../components/Card'

interface Props extends RouteComponentProps {}

interface State {
  users: TableHorizontalData<UserData>[]
}

class Users extends Component<Props, State> {
  tableHeaders: TableHorizontalHeader[] = [
    { heading: i18n("Username"), path: 'username' },
    { heading: i18n("Subscriber"), path: 'site.subscriber.name' },
    { heading: i18n("Site"), path: 'site.name' },
    { heading: i18n("Timeout"), path: 'timeout' },
    { heading: i18n("Permissions"),
      path: 'permissionNames',
      tooltip: ['permissionNames'],
      truncate: true
    },
    { heading: i18n("Created at"), path: 'createdAt', date: true, tooltip: ['user.name'] },
    { heading: i18n("Updated at"), path: 'updatedAt', date: true, tooltip: ['user.name'] },
    { heading: i18n("Actions") }
  ]

  constructor (props: Props) {
    super(props)
    this.state = {
      users: []
    }
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'edit') {
      const pathname = adminRoutes.userEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'resume') {
      userApi.block(id, user => {
        if (!user) return
        const users = userService.block(this.state.users, id)
        this.setState({ users })
      })
    } else if (action === 'start') {
      userApi.unblock(id, user => {
        if (!user) return
        const users = userService.unblock(this.state.users, id)
        this.setState({ users })
      })
    } else if (action === 'token') {
      userApi.generateToken(id, data => {
        if (!data) return
        clipboardUtil.copy(data.token)
      })
    }
  }

  handleCreateClick () {
    this.props.history.push(adminRoutes.userCreate)
  }

  listUsers () {
    userApi.list(users => {
      if (!users) return
      const usersData = userService.tableHorizontalData(users, true)
      this.setState({ users: usersData })
    })
  }

  componentDidMount () {
    this.listUsers()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow heading={i18n("Users")}>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <TableHorizontal
              headers={this.tableHeaders}
              data={this.state.users}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

export default withRouter(Users)
